import React from 'react';
import { render } from 'react-dom';

import Toast, { NotificationTypes } from './Toast';

export default ({ message, type = NotificationTypes.SUCCESS }) => {
  const containerDomNode = document.createElement('div');
  document.body.appendChild(containerDomNode);

  render(<Toast message={message} type={type} />, containerDomNode);
};
